var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWithCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#2563EB",
    stroke: "#2563EB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0484 10.3516C24.2734 10.5766 24.3997 10.8818 24.3997 11.2C24.3997 11.5182 24.2734 11.8234 24.0484 12.0484L14.4484 21.6484C14.2234 21.8734 13.9182 21.9997 13.6 21.9997C13.2818 21.9997 12.9766 21.8734 12.7516 21.6484L7.9516 16.8484C7.73301 16.6221 7.61206 16.3189 7.61479 16.0043C7.61753 15.6897 7.74373 15.3887 7.96622 15.1662C8.18871 14.9437 8.48968 14.8175 8.80432 14.8148C9.11895 14.812 9.42208 14.933 9.6484 15.1516L13.6 19.1032L22.3516 10.3516C22.5766 10.1266 22.8818 10.0002 23.2 10.0002C23.5182 10.0002 23.8234 10.1266 24.0484 10.3516Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWithCheck);
export default __webpack_public_path__ + "static/media/circle_with_check.10c066b63871a2a8767b954604750e90.svg";
export { ForwardRef as ReactComponent };